<template>
    <div class="shadow rounded-border content-image" :style='styleObject'></div>
</template>

<script>
    export default {
        name: "IconaBando",
        data() {
            return {
                styleObject: {
                    backgroundImage: `url(${this.imgUrl})`,
                    backgroundPositionX: "50%",
                    backgroundPositionY: "50%",
                    backgroundSize: "35px 35px",
                    backgroundRepeatX: "no-repeat",
                    backgroundRepeatY: "no-repeat",
                }
            }
        },
        props: ["imgUrl"],
    }
</script>
